import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { ViewComponent } from 'src/app/core/view/view.component';
import { UsersService } from 'src/app/users/users.service';
import { ImportService } from '../import.service';
import {FileUploadModule} from 'primeng/fileupload';
import {HttpClientModule} from '@angular/common/http';
import { Table } from 'primeng/table';
import { ImportDetailComponent } from '../import-detail/import-detail.component';
import { ImportProgressbarComponent } from '../import-detail/import-progressbar/import-progressbar.component';
import { ViewsService } from 'src/app/core/view/views.service';

@Component({
  selector: 'app-import-list',
  templateUrl: './import-list.component.html',
  styleUrls: ['./import-list.component.scss']
})
export class ImportListComponent implements OnInit {
  @ViewChild("view") public view: ViewComponent;
  @ViewChild("grid") private grid: any;
  public imports:any = Array<any>();
  public filters:any = {};
  public totalRecords:number;
  public loading:boolean = false;
  private lastGridEvent:any;

  constructor(
    private importService: ImportService,
    private usersService: UsersService,
    private dialogService: DialogService,
    private messageService: MessageService,
    private coreDialogService: CoreDialogService,
    private viewsService: ViewsService,
    private router: Router
  ) { }

  ngOnInit() {
  }
  
  loadData($event){
    this.lastGridEvent = $event;   
    Promise.resolve(null).then(() => this.loading = true);
    var params = {
      _page: $event.first,
      _pageSize: $event.rows,
      _sortBy: $event.sortField?$event.sortField:"date",
      _sortDirection: $event.sortOrder>0?"desc":"asc"
    };
    params = Object.assign(params, this.filters);
    this.importService.all(params).subscribe(
      data => {
        this.totalRecords = data.totalRows;
        this.imports = data.rows;
        
        Promise.resolve(null).then(() => this.loading = false);
      },
      error => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        
        Promise.resolve(null).then(() => this.loading = false);
      }
    );
  }
  clearFilters(){
    this.filters = {};
    this.search();
  }
  search(){
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  add(importId){
    if(typeof(importId) === "undefined" || importId == null) importId =0;
    const ref = this.dialogService.open(ImportDetailComponent, {
      data: {
        id: importId,
      },
      header: (importId == 0 ? "Nueva importación" : "Reintentar importación"),
      width: '70%'
    });
    ref.onClose.subscribe((data: any) => {
      //if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code); no hay vistas
      this.search();
    })

  }

  delete(importElement) {
    this.coreDialogService.confirm({
      message: "¿Quieres borrar la importación " + importElement.name + "?",
      header: "Confirmación de borrado",
      icon: "pi pi-info-circle",
      accept: () => {
        this.importService.delete(importElement.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: 'success', detail: "Borrado correctamente" });
            this.loadData(this.lastGridEvent);
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        )
      },
      reject: () => {

      }
    })
  }

  saveImport(importData, redirect, closepopup) {
    this.importService.save(importData.id, importData).subscribe(
      data => {
        if (redirect) this.popupConfirmProcessing(importData);
        //if (closepopup) this.dynamicDialogRef.close();
      },
      error => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
      }
    )
  }
  popupConfirmProcessing(importData) {
    const ref = this.dialogService.open(ImportProgressbarComponent, {
      data: {
        id: importData.id
      },
      header: "Importación en progreso",
      width: '35%',
    });
    ref.onClose.subscribe((data: any) => {
      //this.dynamicDialogRef.close();
      this.search();
      //if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);

    })
  }

  openInfo(importData) {
    if (importData.status == "validating") {
      this.importService.summarize(importData.id).subscribe(
        (data: any) => {
          let stringMessage = "";
          data.forEach(element => {
            var textcreate = "Creación";
            if (element.onlyLink) textcreate = "No encontradas"
            stringMessage += "<b>" + element.entity_name_plural + ": </b>" + "<br>" + textcreate + ": " + element.insert + "<br>Actualización: " + element.updates + "<br><br>";
          });

          importData.updatedBy = null;
          importData.createdBy = null;
          importData.entity = null;
          this.coreDialogService.confirm({
            message: stringMessage + '<br>¿Quiere realizar la importación?',
            header: 'Confirmación de importación',
            icon: 'pi pi-info-circle',
            accept: () => {
              importData.status = "validated";
              this.saveImport(importData, true, false);
            },
            reject: () => {
              importData.status = "validating";
              importData.message = stringMessage;
              this.saveImport(importData, false, true);
            }
          });
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      )
     /* this.coreDialogService.confirm({
        message: importData.message + '<br>¿Quiere realizar la importación?',
        header: 'Confirmación de importación',
        icon: 'pi pi-info-circle',
        accept: () => {
          importData.status = "validated";
          importData.updatedBy = null;
          importData.createdBy = null;
          importData.entity = null;

          this.importService.save(importData.id, importData).subscribe(
            data => {
              const ref = this.dialogService.open(ImportProgressbarComponent, {
                data: {
                  id: importData.id
                },
                header: "Importación en progreso",
                width: '35%',
              });
              ref.onClose.subscribe((data: any) => {
                if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
                this.search();
              })
            },
            error => {
              this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
            }
          )        },
        reject: () => {

        }
      });*/
    } else {
      //Es un fallo
      var title = "";
      if (importData.status == 'success') title = "Lo que se realizó";
      this.coreDialogService.notify({
        message: importData.message,
        header: 'Error',
        icon: 'far exclamation-circle',
        color: 'var(--orange-500)',
        accept: () => { }
      });
    }
  }
  

}
